import React from "react";

const SettingsSidebar = ({ activeTab, setActiveTab, participantsCount }) => {
  return (
    <div className="settings-sidebar-menu">
      <h3 className="settings-sidebar-heading">Group Settings</h3>

      <button
        className={`settings-nav-item ${activeTab === "general" ? "active" : ""}`}
        onClick={() => setActiveTab("general")}
        aria-current={activeTab === "general" ? "page" : undefined}
      >
        <span>⚙️</span>
        <span>General Settings</span>
      </button>

      <button
        className={`settings-nav-item ${activeTab === "participants" ? "active" : ""}`}
        onClick={() => setActiveTab("participants")}
        aria-current={activeTab === "participants" ? "page" : undefined}
      >
        <span>👥</span>
        <span>Participants</span>
        <span className="settings-nav-badge">{participantsCount}</span>
      </button>

      <button
        className={`settings-nav-item ${activeTab === "cover" ? "active" : ""}`}
        onClick={() => setActiveTab("cover")}
        aria-current={activeTab === "cover" ? "page" : undefined}
      >
        <span>🖼️</span>
        <span>Group Cover Icon</span>
      </button>

      <button
        className={`settings-nav-item ${activeTab === "watermark" ? "active" : ""}`}
        onClick={() => setActiveTab("watermark")}
        aria-current={activeTab === "watermark" ? "page" : undefined}
      >
        <span>💧</span>
        <span>Watermark Settings</span>
      </button>
    </div>
  );
};

export default SettingsSidebar;
